import { useContext } from 'react';
import { BackendDispatchContext } from '../context/backend-context';
import { useCreateEntity } from './use-create-entity';

export const useCreateOrganization = () => {
  const { asyncActions } = useContext(BackendDispatchContext)

  return useCreateEntity(asyncActions!.createOrganization.bind(asyncActions));
}